import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.01079 5.94177L12.1624 12.7683L19.3139 5.94177L20.0044 6.66513L12.1624 14.1507L4.32031 6.66513L5.01079 5.94177Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.97151 12.7195L5.11855 17.7283L4.32593 17.1186L8.17888 12.1097L8.97151 12.7195Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.1457 12.1097L19.9986 17.1186L19.206 17.7283L15.353 12.7195L16.1457 12.1097Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.87824 4.49983C3.27613 4.10195 3.81577 3.87842 4.37846 3.87842H19.946C20.5087 3.87842 21.0484 4.10195 21.4462 4.49983C21.8441 4.89771 22.0676 5.43735 22.0676 6.00004V18.3244C22.0676 18.8871 21.8441 19.4267 21.4462 19.8246C21.0484 20.2225 20.5087 20.446 19.946 20.446H4.37846C3.81577 20.446 3.27613 20.2225 2.87824 19.8246C2.48036 19.4267 2.25684 18.8871 2.25684 18.3244V6.00004C2.25684 5.43735 2.48036 4.89771 2.87824 4.49983ZM4.37846 4.87842C4.08098 4.87842 3.7957 4.99659 3.58535 5.20693C3.37501 5.41728 3.25684 5.70257 3.25684 6.00004V18.3244C3.25684 18.6218 3.37501 18.9071 3.58535 19.1175C3.7957 19.3278 4.08098 19.446 4.37846 19.446H19.946C20.2435 19.446 20.5288 19.3278 20.7391 19.1175C20.9495 18.9071 21.0676 18.6218 21.0676 18.3244V6.00004C21.0676 5.70257 20.9495 5.41728 20.7391 5.20693C20.5288 4.99659 20.2435 4.87842 19.946 4.87842H4.37846Z",
			fill: "white"
		})
	]
});
export default SvgEmail;
